import { IFramePlayerErrorCode } from 'iframe/ts/player/model/error/IFramePlayerErrorCode';
export const IFramePlayerErrorFatal = {
    [IFramePlayerErrorCode.P1000]: false,
    [IFramePlayerErrorCode.P1001]: true,
    [IFramePlayerErrorCode.P1002]: true,
    [IFramePlayerErrorCode.P1010]: false,
    [IFramePlayerErrorCode.P1011]: true
};
